import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useLocation } from 'react-router-dom';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const MAIN_LINKS = [
  { to: '/', label: 'Somar Horas' },
  { to: '/calculadora-de-horas-trabalhadas', label: 'Horas Trabalhadas' },
  { to: '/calculadora-de-horas-extras', label: 'Horas Extras' },
  { to: '/calculadora-de-adicional-noturno', label: 'Adicional Noturno' },
  { to: '/calculadora-de-banco-de-horas', label: 'Banco de Horas' },
];

const NotFoundPage = () => {
  const { pathname } = useLocation();
  const ownUrl = `https://calculadoradehoras.net.br${pathname}`;

  // The hosting serves the pre-rendered homepage HTML for unknown URLs, so its
  // robots, canonical, hreflang and JSON-LD tags are still in <head> when this
  // page mounts. React 19 + react-helmet-async v3 do not mark their tags with
  // data-rh, so match on values instead and keep only this page's own tags.
  useEffect(() => {
    const head = document.head;
    head.querySelectorAll('meta[name="robots"]').forEach((el) => {
      if (el.getAttribute('content') !== 'noindex, follow') el.remove();
    });
    head.querySelectorAll('link[rel="canonical"]').forEach((el) => {
      if (el.getAttribute('href') !== ownUrl) el.remove();
    });
    head.querySelectorAll('link[rel="alternate"][hreflang]').forEach((el) => el.remove());
    head.querySelectorAll('script[type="application/ld+json"]').forEach((el) => el.remove());
  }, [ownUrl]);

  return (
    <>
      <Helmet>
        <html lang="pt-BR" />
        <title>Página não encontrada | Calculadora de Horas</title>
        {/* noindex so the CDN-served 200 with this content is not indexed */}
        <meta name="robots" content="noindex, follow" />
        {/* Override whatever canonical the fallback index.html pre-rendered */}
        <link rel="canonical" href={`https://calculadoradehoras.net.br${pathname}`} />
      </Helmet>

      <Navigation />

      <main className="max-w-2xl mx-auto px-4 py-16 text-center">
        <p className="text-8xl font-heading font-bold text-primary mb-4">404</p>
        <h1 className="text-2xl font-heading font-bold text-dark-text mb-3">
          Página não encontrada
        </h1>
        <p className="text-body-text mb-8">
          O endereço que você acessou não existe ou foi removido.
        </p>

        <Link
          to="/"
          className="inline-block bg-primary text-white font-semibold px-6 py-3 rounded-lg hover:bg-primary-dark transition-colors mb-10"
        >
          Voltar à página inicial
        </Link>

        <div className="border-t border-border-color pt-8">
          <p className="text-sm text-body-text mb-4 font-medium">Calculadoras disponíveis:</p>
          <ul className="flex flex-wrap justify-center gap-3">
            {MAIN_LINKS.map(({ to, label }) => (
              <li key={to}>
                <Link to={to} className="text-sm text-primary hover:underline">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default NotFoundPage;
